a.nfcscanner = (function(){
	var my = {
		reader: null,
		token:null,
		start: function(o){
			var cb_result = o.result || function(){};
			var cb_error = o.error || function(){};
			tpl.run({
				tpl: '/tpl/nfcreader.ejs?v=' + v,
				data: {},
				cb: function(c){
					my.token = a.popup.create({
						slideFrom: 'fromtop',
						title: 'Read NFC tag',
						content: c,
						disable_topbar: false,
						disable_back: true,
						css_class: 'qrscanner',
						ready: function(token){
							var win = $('#popupid_' + token);

							// Start the NFC reader
							my.startNFCReader({
								result: function(res){
									cb_result(res);
								},
								error: function(err){
									cb_error(err);
								}
							});

							$('li[data-action="close"]', win).unbind('click').click(function(){
								my.stopNFCReader();
							});
						},
						close: function(){
						}
					});
				}
			});
		},

		startNFCReader: async function(callbacks) {
			// Check if NFC is available
			if ('NDEFReader' in window) {
				try {
					this.reader = new NDEFReader();
					await this.reader.scan();

					const onReading = event => {
						const message = event.message;
						if (message.records.length === 0) {
							a.s.growl.create('Error','The NFC tag seems to be empty',{ duration:4000 });
						}
						else {
							for (const record of message.records) {
								switch (record.recordType) {
									case "text":
										// Decode text record
										const textDecoder = new TextDecoder(record.encoding);
										const text = textDecoder.decode(record.data);
										if (callbacks.result) {
											callbacks.result(text);
										}
										break;
									case "url":
										// Decode URL record
										const urlDecoder = new TextDecoder();
										const url = urlDecoder.decode(record.data);
										if (callbacks.result) {
											callbacks.result(url);
										}
										break;
									default:
										console.log(`Unknown record type: ${record.recordType}`);
								}
							}
						}

						// Stop the reader after reading
						this.stopNFCReader();
					};

					const onReadingError = () => {
						console.error("Error while reading NFC tag");
						if (callbacks.error) {
							callbacks.error("Error while reading NFC tag");
						}

						// Stop the reader on error
						this.stopNFCReader();
					};

					// Bind `this` to the functions to maintain context
					this.reader.onreading = onReading.bind(this);
					this.reader.onreadingerror = onReadingError.bind(this);

				} catch (error) {
					console.error(`Error: ${error}`);
					if (callbacks.error) {
						callbacks.error(error);
					}
				}
			} else {
				console.error("Web NFC is not supported on this device.");
				if (callbacks.error) {
					callbacks.error("Web NFC is not supported on this device.");
				}
			}
		},

		stopNFCReader: function() {
			if (this.reader) {
				this.reader.onreading = null;
				this.reader.onreadingerror = null;
				this.reader = null;
			}
			a.popup.remove(my.token,function(){});
		}
	};
	return my;
}());
